import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import QuizIcon from '@mui/icons-material/Quiz';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import SchoolIcon from '@mui/icons-material/School';

export default function Schedule() {
    return (
      <div>
        <br />
        <br />
        <br />
        <div className='container' style={{ textAlign: 'center' }}>
          <h1 style={{ textAlign: 'center' }}>BootCamp Journey</h1>
        </div>     
        <br />
        <br />
  <VerticalTimeline animate = {false} lineColor = "#e8f1f5">

  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="31 May'24"
    iconStyle={{ background: '#37715d', color: '#fff' }}
    icon={<QuizIcon />}
  >
    <h3 className="vertical-timeline-element-title">Week 0</h3>
    <h4 className="vertical-timeline-element-subtitle">Know Your Entrepreneurial Potential</h4>
    <p> Take a Self-Assessment test to evalutate your Entrepreneurial Quotient</p>
    
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="3 June'24 - 7 June'24 "
    // contentStyle={{ background: '#f6f6f6', color: '#fff' }}
    // contentArrowStyle={{ borderRight: '7px solid  var(--primary-color)' }}
    iconStyle={{ background: '#37715d', color: '#fff' }}
    icon={<TipsAndUpdatesIcon />}
  >   
    <h3 className="vertical-timeline-element-title">Week 1</h3>
    <h4 className="vertical-timeline-element-subtitle">Ideation Workshop</h4>
    <p>
    <ul style={{ listStyleType: 'none', padding: "0px" }}>
      <li> M. Ideation - Identify a Problem worth Solving </li>
      <li>W. Customer Discovery: Know thy Customer and Market</li>
      <li>F. Value Proposition & Competition Analysis</li>
    </ul>
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="10 June'24 - 14 June'24"
    iconStyle={{ background: '#37715d', color: '#fff' }}
    icon={<AttachMoneyIcon />}
  >
    <h3 className="vertical-timeline-element-title">Week 2</h3>
    <h4 className="vertical-timeline-element-subtitle">Show Me the Money</h4>
    <p>
    <ul style={{ listStyleType: 'none', padding: "0px" }}>
        <li>M. Business Model & Revenue Streams - How to flow in the money!</li>
        <li>W. Prototyping and Validation</li>
        <li>F. Art of Pitching and Storytelling </li>
    </ul>
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="20 June'24 - 24 June'24"
    iconStyle={{ background: '#37715d', color: '#fff' }}
    icon={<TrendingUpIcon />}
  >
    <h3 className="vertical-timeline-element-title">Week 3</h3>
    <h4 className="vertical-timeline-element-subtitle">Sell your Vision</h4>
    <p>
    Pitch Practices and 1:1 and 1:N Mentoring Sessions
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="29 June'24"
    iconStyle={{ background: '#37715d', color: '#fff' }}
    icon={<CoPresentIcon />}
  >
    <h3 className="vertical-timeline-element-title">Week 4</h3>
    <h4 className="vertical-timeline-element-subtitle">Show what you Got!</h4>
    <p>
    Final Battle - Pitch your Idea and Business Model to a Jury

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="6 July'24"
    iconStyle={{ background: '#37715d', color: '#fff' }}
    icon={<SchoolIcon />}
  >
    <h3 className="vertical-timeline-element-title">Week 5</h3>
    <h4 className="vertical-timeline-element-subtitle">Hurray!</h4>
    <p>
     Graduation Ceremony for qualified participants
    </p>
  </VerticalTimelineElement>
  {/* <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="November 2012"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<SchoolIcon />}
  >
    <h3 className="vertical-timeline-element-title">Agile Development Scrum Master</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
    <p>
      Creative Direction, User Experience, Visual Design
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="2002 - 2006"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<SchoolIcon />}
  >
    <h3 className="vertical-timeline-element-title">Bachelor of Science in Interactive Digital Media Visual Imaging</h3>
    <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
    <p>
      Creative Direction, Visual Design
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
    icon={<StarIcon />}
  /> */}
</VerticalTimeline>
</div>
);
}